import { cva } from 'class-variance-authority'

export const linkStyles = cva('cursor-pointer', {
  variants: {
    intent: {
      textDark: 'underline text-purple-100 focus:outline-purple-100/20 focus:outline-4 focus:rounded-lg',
      textLight: 'underline text-white focus:outline-white/20 focus:outline-4 focus:rounded-lg',
      primaryLight: '',
      primaryDark: '',
      orange: '',
      teal: '',
      outlineLight: '',
      outlineDark: '',

      /** use wrapper for styles that is not reusable, e.g cards */
      wrapper: '',
    },
    status: {
      default: '',
      loading: '',
    },
    size: {
      xs: 'text-xs',
      sm: 'text-base',
      md: 'text-md',
      lg: 'text-xl',
    },
  },
  defaultVariants: {
    intent: 'textDark',
    status: 'default',
  },
  compoundVariants: [
    {
      intent: ['primaryLight', 'primaryDark', 'orange', 'teal', 'outlineLight', 'outlineDark'],
      className:
        'px-24 py-16 focus:outline-4 rounded-lg disabled:text-neutral-60 disabled:border-neutral-50 disabled:bg-grey-30 border border-solid',
    },
    {
      intent: 'primaryLight',
      status: 'default',
      className:
        'text-purple-100 focus:outline-purple-100/20 focus:bg-purple-10 active:bg-purple-pressedLight bg-white hover:bg-purple-10',
    },
    {
      intent: 'primaryDark',
      status: 'default',
      className:
        'bg-purple-100 focus:outline-purple-100/20 text-white hover:bg-purple-hoverDark focus:bg-purple-hoverDark active:bg-purple-pressedDark',
    },
    {
      intent: 'orange',
      status: 'default',
      className:
        'bg-orange-100 border-orange-100 text-black hover:bg-orange-hover focus:bg-orange-hover active:bg-orange-pressed focus:outline-orange-100/20',
    },
    {
      intent: 'teal',
      status: 'default',
      className:
        'bg-teal-100 text-black hover:bg-teal-hover focus:bg-teal-hover focus:outline-teal-50 active:bg-teal-pressed',
    },
    {
      intent: 'outlineLight',
      status: 'default',
      className:
        'text-white bg-transparent border border-solid hover:text-purple-100 hover:bg-white focus:bg-white focus:text-purple-100 active:text-purple-100 active:bg-neutral-30 border-neutral-50 hover:border-white focus:border-white active:border-white focus:outline-white/20',
    },
    {
      intent: 'outlineDark',
      status: 'default',
      className:
        'text-purple-100 border-purple-100 border border-solid bg-transparent hover:text-white hover:bg-purple-100 focus:text-white focus:bg-purple-100 active:bg-purple-hoverDark active:text-white',
    },
    {
      intent: 'primaryLight',
      status: 'loading',
      className: 'text-purple-100 bg-purple-pressedLight',
    },
    {
      intent: 'primaryDark',
      status: 'loading',
      className: 'text-white bg-purple-pressedDark',
    },
    {
      intent: 'orange',
      status: 'loading',
      className: 'text-black bg-orange-pressed',
    },
    {
      intent: 'teal',
      status: 'loading',
      className: 'text-black bg-teal-pressed',
    },
    {
      intent: 'outlineLight',
      status: 'loading',
      className: 'text-purple-100 bg-neutral-30 border-white',
    },
    {
      intent: 'outlineDark',
      status: 'loading',
      className: 'bg-purple-hoverDark text-white border-purple-100',
    },
  ],
})
